export default __webpack_public_path__ + "466c91e504fc7469c018cd7d3ccf63a8.png";